import { AgButton, AgModal, AgModalActions, AgModalContent } from 'src/components/ui';
import { useNavigationBlocker } from 'src/lib/routing';
import { useEditingState } from 'src/providers/EditingStateProvider';

export default function NavigationBlocker() {
  const isActive = useEditingState((state) => state.getIsActive());
  const blocker = useNavigationBlocker({ when: isActive });

  return (
    <AgModal open={blocker.isBlocked} onClose={() => blocker.abort()}>
      <AgModalContent>Some changes are still saving. Are you sure you want to leave?</AgModalContent>
      <AgModalActions cancel={null}>
        <AgButton variant="ghost" onPress={() => blocker.confirm()}>
          Leave anyways
        </AgButton>
        <AgButton variant="primary" onPress={() => blocker.abort()}>
          Stay
        </AgButton>
      </AgModalActions>
    </AgModal>
  );
}
